module.exports = __webpack_public_path__ + "media/images/icon-bw-line-253e34d5cf75e7b2561969d9317166cb.png";